import { useEffect, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import { HelmetProvider } from 'react-helmet-async';
import { FeatureFlagsContextProvider } from '@fff-web/feature-flags';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { PricesProvider } from '@fff-web/fff-payments';
import { FontAwesome } from '@fff-web/fff-ui-shared';
import { useUserContext } from '@fff-web/fff-utilities';
import AppRoutes from './AppRoutes';
import { SubscriptionPlansContext } from './context/SubscriptionPlansContext';
import { getSubscriptionPlans } from './services/localization';
import { appEnv } from './utils/env';
import { getUUID } from './utils/Optimizely/experiments';
import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import store from './pages/MyAccount/store';

const optimizelyClientInstance = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_FRONT_END_SDK_KEY,
  logLevel: 'error',
});

/**
 *
 */
function App() {
  const [subscriptionPlans, setSubscriptionPlans] = useState(undefined);
  const { userInfo } = useUserContext();
  const userId = userInfo?.user?.userId ?? getUUID();
  const queryClient = new QueryClient();

  useEffect(() => {
    getSubscriptionPlans().then((response) => {
      setSubscriptionPlans(response);
    });
  }, []);

  useEffect(() => {
    if (userId) {
      datadogRum.setGlobalContextProperty('userId', userId);
      datadogLogs.setGlobalContextProperty('userId', userId);
    }
  }, [userId]);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <UniversalNavigationContextProvider>
          <OptimizelyProvider optimizely={optimizelyClientInstance} user={{ id: String(userId) }}>
            <PricesProvider>
              <FontAwesome />
              <SubscriptionPlansContext.Provider value={{ subscriptionPlans }}>
                <FeatureFlagsContextProvider appEnv={appEnv}>
                  <Provider store={store}>
                    <AppRoutes />
                  </Provider>
                </FeatureFlagsContextProvider>
              </SubscriptionPlansContext.Provider>
            </PricesProvider>
          </OptimizelyProvider>
        </UniversalNavigationContextProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
